import { Flex } from '@teamsparta/stack-flex';
import { Text } from '@teamsparta/stack-text';
import { isNil } from '@teamsparta/utils';

import type { Course } from '@/types';

import { useGetCourseBadge } from './hooks';

interface Props {
  courseType: Course;
  customBadge?: {
    color: string;
    backgroundColor: string;
    name: string;
  };
}

export function Badge({ courseType, customBadge }: Props) {
  const badge = useGetCourseBadge({ courseType });

  const badgeStyle = {
    background: customBadge?.backgroundColor ?? badge?.backgroundColor,
    color: customBadge?.color ?? badge?.textColor,
    name: customBadge?.name ?? badge?.name,
  };

  // 뱃지 데이터가 하나라도 이상하면 렌더링 X
  if (Object.values(badgeStyle).every((value) => isNil(value))) {
    return null;
  }

  return (
    <Flex
      padding='1px 4px'
      align='center'
      justify='center'
      style={{ borderRadius: 4, backgroundColor: badgeStyle.background }}
    >
      <Text as='span' font='tag2' color={badgeStyle.color}>
        {badgeStyle.name}
      </Text>
    </Flex>
  );
}
